<template>
  <SwipeContainer
        title="Swipe left to reject an outfit"
        subtext="We will filter out items and outfits that you dislike"
        type="reject" />
</template>

<script>
    import SwipeContainer from './swipe-container.vue';

    export default {
        components: {
            SwipeContainer
        }
    };
</script>
